import React, {useState, useEffect, useRef, Fragment} from 'react';
import Popup from './Popup';
import {Enumeration, Video, Uploader, Form, Text, Select, GoogleLogin, TextEditor, Loader, Date_picker, Chip_input, Popup as Popup_component} from '../../../../../../../components';
import {Field} from 'react-final-form';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import ScheduleIcon from '@material-ui/icons/Schedule';
import WebIcon from '@material-ui/icons/Web';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import axios from 'axios';
import arrayMutators from 'final-form-arrays';
import EmailIcon from '@material-ui/icons/Email';
import DealSelect from './DealSelect';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import GaugeChart from 'react-gauge-chart';
import {connect} from 'react-redux';
import FolderSelector from '../../../../../../../components/FormSections/Fields/FolderSelector';




function Preview_popup(props){

  return(
    <Popup_component  always_open
            height={'95vh'}
            width={'100vw'}
            maxWidth={'800px'}
            title={props.template.name}
            icon={<WebIcon color='primary'/>}
            content={
              <div style={{width:'100vw', height:'calc(95vh - 100px)', maxWidth:'800px', position:'relative'}}>
              <div style={{width:'100%', height:'calc(100% - 150px)', paddingTop:'20px', maxWidth:'800px', position:'relative', overflowY:'scroll', paddingBottom:'20px'}}>
                  <Typography style={{width:'100%', position:'relative'}}>
                  {<div style={{width:'calc(100% - 40px)', marginLeft:'20px', marginTop:'20px'}} dangerouslySetInnerHTML={{__html:props.template.html}}></div>}
                  </Typography>
              </div>
              {(props.template.html_template_attachments.length>0)?<div style={{width:'100%', height:'100px', display:'flex', alignItems:'center', borderTop:'1px dotted black', paddingTop:'10px', paddingBottom:'10px', overflowX:'scroll'}}><Typography>{props.template.html_template_attachments.map(function(ha){return(
                <span onClick={()=>{window.location.href='/api/safeDownload/'+ha.id;}} style={{borderRadius:'25px', borderStyle:'solid', borderColor:'grey', borderWidth:'1px', padding:'5px', paddingLeft:'10px', paddingRight:'15px', cursor:'pointer', marginLeft:'10px', marginRight:'10px'}}>{ha.name+'.'+ha.extension}</span>
              )})}</Typography></div>:null}
              </div>
            }
            handleClose={props.handleClose}
    />
  )
}

function Email_popup(props){
  let draft_props = useRef({
    schedule: false,
    cc: false,
    bcc: false,
    reply_to: false,
    template: false,
    sequence: false
  });


  const [updateDateTime, setUpdateDateTime]=useState();
  const [schedule, setScheduleInner]=useState(draft_props.current.schedule);
  const [cc, setCcInner]=useState(draft_props.current.cc);
  const [bcc, setBccInner]=useState(draft_props.current.bcc);
  const [reply_to, setReplyToInner]=useState(draft_props.current.reply_to);
  const [contact_id, setContactId]=useState((props.initial_email!=undefined)?props.initial_email.contact_id:undefined);
  const [template, setTemplateInner]=useState(draft_props.current.template);
  const [sequence, setSequenceInner]=useState(draft_props.current.sequence);

  function setTemplate(x){setTemplateInner(x); draft_props.current.template=x;}
  function setSequence(x) { setSequenceInner(x); draft_props.current.sequence = x; }
  function setCc(x) { setCcInner(x); draft_props.current.cc = x; }
  function setBcc(x) { setBccInner(x); draft_props.current.bcc = x; }
  function setReplyTo(x) { setReplyToInner(x); draft_props.current.reply_to = x; }
  function setSchedule(x) { setScheduleInner(x); draft_props.current.schedule = x; }


  function setDraftDefaults(x){
    console.log(x, 'SET DRAFT DEFAULTS');
    if(x!=undefined){
      draft_props.current=x;
      setTemplateInner(x.template);
      setSequenceInner(x.sequence);
      setCcInner(x.cc);
      setBccInner(x.bcc);
      setReplyTo(x.reply_to);
      setSchedule(x.schedule);
    }
  }

  const [ai_template, setAiTemplate]=useState(false);
  const [ai_email_loading, setAiEmailLoading]=useState();
  const [permission, setPermission]=useState(false);
  const [preview_popup, setPreviewPopup]=useState(undefined);
  const [subject_required, setSubjectRequired]=useState(false);
  let first_time_sequence=useRef(true);
  let first_time_template=useRef(true);
  let first_time_rta=useRef(true);

  let formRef=useRef();
  let fp=useRef();


  useEffect(()=>{
    if(props.gmail==undefined){props.getGmailSetup();}
    if(props.initial_email!=undefined){setDraftDefaults(props.initial_email.draft_props);}
  },[]);

  function onSubmit(params){
    for(let cont of props.company.contacts){
      for(let ce of cont.contact_emails){
        if(ce.id==params.contact_email_id){
          params.contact_id=ce.contact_id; break;
        }
      }
    }
    if(params=='error'){return null;}
    props.handleClose();
    props.createTimelineItem('emails', params);
    if(params.completed_task_id!=undefined && params.no_follow_up!=true){props.setNewTaskPrompt(true);}
    if(params.sequence_id!=undefined){localStorage.setItem('first_sequence',params.sequence_id);}
    if(params.template_id!=undefined){localStorage.setItem('first_template',params.template_id);}
    if(params.from_id!=undefined){localStorage.setItem('first_from',params.from_id);}
  }



 function generateAiEmail(contact_id, template_id, f_subject, f_content){
   setAiEmailLoading('loading');
   axios.get('/api/ai/generateEmail/'+props.company.id+'/'+contact_id+'/'+template_id).then(function(response){
     console.log(response.data, 'CRAZY AI');
     f_subject.input.onChange(response.data.subject);
     f_content.input.onChange(response.data.html_email);
     setAiEmailLoading('loaded');
   });
 }

  let to_list=[];
  let contact={};
  if(props.company!=undefined){
      for(let d of props.company.contacts){
        if(d.unsubscribed_from_email!=true && d.pivot.active_at_company==true){
          for(let ce of d.contact_emails){
            if(ce.email_status!='UNSUBSCRIBED' && ce.email_status!='SPAM_COMPLAINT'){ //WE COULD JUST RELY ON CONTACT UNSUBSCRIBE
              if(d.id==contact_id){contact=d;}
              if(ce.email!=undefined){to_list.push({id:ce.id, contact_id:d.id, name:d.first_name+' '+d.last_name+' ('+ce.email.email+')'})}
      }}}}
    }


  let first_from=Number(localStorage.getItem('first_from'));

  let from_list=[]; let from_main=null;
  if(props.gmail!=undefined && props.gmail.addresses!=undefined){
    for(let x of props.gmail.addresses){
      let smtp_login={}; if(props.gmail.smtp_logins!=undefined){for(let sl of props.gmail.smtp_logins){if(sl.id==x.smtp_login_id){smtp_login=sl;}}}
      from_list.push({id:x.id, name:(props.gmail.smtp_logins.length==1)?x.email:smtp_login.connection_name+': '+x.email});
      if(x.main==true){from_main=x.id;}
    }
  }
  if(from_main==null){from_main=first_from;}

  if(props.gmail!=undefined && props.gmail!='disconnected' && from_list.length!=0 && permission==false && (props.workspace!=null && (props.workspace.active_subscription!=undefined || props.workspace.free_account==true))){setPermission(true);}


  let ai_template_list=[]; let template_list=[]; let sequence_list=[];
  let first_template=Number(localStorage.getItem('first_template'));
  let first_sequence=Number(localStorage.getItem('first_sequence'));
  let first_template_folder='all_folders';
  let first_sequence_folder='all_folders';
  

  if(props.templates_index==true){for(let t_key in props.templates){let xy=props.templates[t_key]; if(t_key==first_template){first_template_folder=(xy.folder_id==null || xy.folder_id==undefined)?'main_folder':xy.folder_id;} if(xy.disabled!=true && (xy.workspace_share==true || xy.user_id==props.me.id)){let name=xy.name; if(xy.sent_count>10){if(xy.open_count==0){name=name+'       (0.0%)'}else{name=name+' ('+(xy.open_count/(xy.sent_count/100)).toFixed(1)+'%)'}}
  if(xy.template_type=='AI_TEMPLATE'){
    if(t_key==first_template){ai_template_list.unshift({id:t_key, name:name, folder_id:xy.folder_id});}else{ai_template_list.push({id:t_key, name:name, folder_id:xy.folder_id});}
  }else{
    if(t_key==first_template){template_list.unshift({id:t_key, name:name, folder_id:xy.folder_id});}else{template_list.push({id:t_key, name:name, folder_id:xy.folder_id});}
  }
  }}}else if(first_time_template.current==true){props.getTemplates(); first_time_template.current=false;}
  if (props.sequences != undefined && props.templates_index == true) { for (let s_key in props.sequences) { if (s_key == first_sequence) { first_sequence_folder = (props.sequences[s_key].folder_id == null || props.sequences[s_key].folder_id == undefined) ? 'main_folder' : props.sequences[s_key].folder_id; sequence_list.unshift({id:s_key, name:props.sequences[s_key].name, folder_id:props.sequences[s_key].folder_id});}else{sequence_list.push({id:s_key, name:props.sequences[s_key].name, folder_id:props.sequences[s_key].folder_id});}}}else if(first_time_sequence.current==true){props.getSequences(); first_time_sequence.current=false;}

  function changeDefaultDate(date_time, func){if(date_time!=null){ setSchedule(true);func.onChange(date_time); }else{setSchedule(false); func.onChange('');}}
  let initial_deal_id=(props.initial_email!=undefined && props.initial_email.deal_id!=undefined)?props.initial_email.deal_id:(props.main_deals==undefined || props.main_deals[props.company.id]==undefined)?undefined:props.main_deals[props.company.id];

  let reply_to_address=undefined; if(from_main!=undefined && props.gmail!=undefined && props.gmail!='disconnected' && props.gmail.addresses!=undefined){let from=undefined; for(let ga of props.gmail.addresses){if(ga.id==from_main){from=ga;}} if(from!=undefined && from.reply_to_address!=undefined){reply_to_address=from.reply_to_address; if(first_time_rta.current==true){first_time_rta.current=false; setReplyTo(true);}}}
  if(props.templates==undefined){return null;}
  console.log(props, JSON.parse(JSON.stringify(props.initial_email)), 'EMAIL_POPUP');

  function fromChange(props, from_id, template_id, f, seq=false){let from=getFrom(props, from_id); let template=(template_id==undefined)?undefined:(seq==true)?getTemplateFromSequence(props, template_id):getTemplate(props, template_id); if(template==undefined || template.reply_to_address==undefined){f.input.onChange(from.reply_to_address); setReplyTo(from.reply_to_address!=undefined);}else{f.input.onChange(template.reply_to_address); setReplyTo(true);}}
  function templateChange(props, from_id, template_id, f){setAiEmailLoading(undefined); let from=getFrom(props, from_id);  let template=getTemplate(props, template_id); if(template!=undefined){if(template.reply_to_address!=undefined || from.reply_to_address!=undefined){setReplyTo(true);}else {setReplyTo(false);} f.input.onChange((template.reply_to_address!=undefined)?template.reply_to_address:from.reply_to_address);}}
  function sequenceChange(props, from_id, sequence_id, f){let template=getTemplateFromSequence(props, sequence_id); templateChange(props, from_id, template.id, f);}

  function getInitialContactEmail(ie, contact){
    console.log(ie, contact, 'FOCUS HERE');
    if(ie.contact_email_id==undefined && contact!=undefined && contact.contact_emails!=undefined && contact.contact_emails[0]!=undefined){
      return contact.contact_emails[0].id;
    }else{
      return ie.contact_email_id;
    }
  }


  return(
    <Fragment>
      <Popup setDraftDefaults={setDraftDefaults} draft_props={draft_props} initial_values={props.initial_email} openDraft={props.reOpen} draft_type="EMAIL" company_id={props.company.id} form_props={fp} maxWidth='900px' submit_button icon={(template==true)?<WebIcon color='primary'/>:(sequence==true)?<ScheduleIcon color='primary'/>:<EmailIcon color='primary'/>} title={(template==true)?'Send email template':(sequence==true)?'Send email sequence':'Send Email'} handleClose={()=>{if(props.initial_email!=undefined && props.initial_email.completed_task_id!=undefined && props.initial_email.ignore_complete_anyway!=true){props.handleClose(props.initial_email.completed_task_id);}else{props.handleClose();}}}
 accept_button={(permission==false)?'':'Send'} button_text={(permission==false)?'':'Send'} accept_button_click={(permission==false)?undefined:()=>{fp.current.form.submit()}} content={
      <Form
        prepareSubmit={(params)=>{
          formRef.current.reportValidity();
          if(formRef.current.checkValidity()==false){return 'error';}
          if(params.placeholders!=undefined){params.placeholders=JSON.stringify(params.placeholders);}
          if(params.cc!='' && params.cc!=undefined){let new_cc=[]; for(let cc of params.cc){new_cc.push(cc.email);} params.cc=new_cc;}
          if(params.bcc!='' && params.bcc!=undefined){let new_bcc=[]; for(let bcc of params.bcc){new_bcc.push(bcc.email);} params.bcc=new_bcc;}

          if(reply_to==false && params.reply_to_address!=undefined){delete params.reply_to_address;}
          if(template==true){
            delete params.sequence_id;
            delete params.subject;
            delete params.content;
            delete params.upload_documents;
          }else if(sequence==true){
            delete params.template_id;
            delete params.content;
            delete params.subject;
            delete params.upload_documents;
          }else{
            if(params.subject=='' || params.subject==undefined){setSubjectRequired(true); return 'error';}
            delete params.template_id;
            delete params.sequence_id;
          }
          return params;
        }}
        onSubmit={onSubmit}
        initialValues={(props.initial_email==undefined)?{
          unsubscribe_button:(props.workspace==undefined)?false:props.workspace.unsubscribe_button_default_on,
          reply_to_address:reply_to_address,
          template_id: first_template,
          sequence_id: first_sequence,
          templates_folder_id: first_template_folder,
          sequences_folder_id: first_sequence_folder,
          deal_id:initial_deal_id,
          from_id:from_main,
          company_id:(props.company==undefined)?undefined:props.company.id
        }:
        {
          unsubscribe_button:(props.workspace==undefined)?false:props.workspace.unsubscribe_button_default_on,
          from_id:from_main,
          company_id:(props.company==undefined)?undefined:props.company.id,
          reply_to_address:reply_to_address,
          template_id:first_template,
          sequence_id:first_sequence,
          templates_folder_id:first_template_folder,
          sequences_folder_id:first_sequence_folder,
          ...props.initial_email,
          contact_email_id:getInitialContactEmail(props.initial_email, contact),
          deal_id:initial_deal_id
        }}
        mutators={{
          ...arrayMutators
        }}
        handleClose={props.handleClose}
          >
        {form_props =>{ fp.current=form_props; return(
        <form ref={formRef} onSubmit={form_props.handleSubmit}>{(props.gmail==undefined)?
          <div style={{display:'block', minHeight:'400px',width:'90vw', maxWidth:'900px'}}/>
          :(permission==false)?
        <div style={{display:'block', height:'400px', width:'90vw', maxWidth:'900px'}}>
          <Grid container>
            <Grid item xs={12}><Video style={{width:'100%', height:'340px', marginBottom:'0px', marginTop:'0px'}} video='EMAIL_INTRO' autoplay/></Grid>
            <Grid item xs={12} style={{display:'flex', justifyContent:'center', alignItems:'center', marginTop:'20px'}}><Button color='secondary' variant='contained' onClick={()=>{window.location.href='/integrations';}}>Connect</Button></Grid>
          </Grid>
        </div>
        :
        <div style={{display:'flex', justifyContent:'center', minHeight:'200px', width:'90vw', maxWidth:'900px'}}>
        <Field name='reply_to_address'>{(f)=><Field name='from_id'>{(ff)=><Field name='template_id'>{(ft)=><Field name='template_id'>{(fs)=>
          <Fragment>

          <div style={{position:'absolute',top:'8px',right:'20px'}}>
                {(template==true||sequence==true||ai_template==true)?<Tooltip title='Send email'><EmailIcon color='primary' style={{cursor:'pointer'}} onClick={()=>{setAiTemplate(false); setTemplate(false);setSequence(false);fromChange(props,ff.input.value,undefined,f);}}/></Tooltip>
                :<Tooltip title='Send template'><WebIcon color='primary' style={{cursor:'pointer'}} onClick={()=>{setAiTemplate(false); setTemplate(true);setSequence(false);templateChange(props,ff.input.value,ft.input.value,f);}}/></Tooltip>}
          </div>
          <div style={{position:'absolute',top:'8px',right:'70px'}}>
                {(sequence==false && ai_template==false)?<Tooltip title='Send sequence'><ScheduleIcon color='primary' style={{cursor:'pointer'}} onClick={()=>{setAiTemplate(false); setSequence(true);setTemplate(false);sequenceChange(props,ff.input.value,fs.input.value,f);}}/></Tooltip>
                :<Tooltip title='Send template'><WebIcon color='primary' style={{cursor:'pointer'}} onClick={()=>{setAiTemplate(false); setTemplate(true);setSequence(false);templateChange(props,ff.input.value,ft.input.value,f);}}/></Tooltip>}
          </div>
          {(!window.location.href.includes('https://test.prospectsafari.com'))?null:<div style={{position:'absolute',top:'8px',right:'120px'}}>
                {(ai_template==false)?<Tooltip title='Send ai email'><img src='/images/ai_icon.png' style={{cursor:'pointer', width:'30px', marginTop:'-5px'}} onClick={()=>{setAiTemplate(true); setSequence(false);setTemplate(false); templateChange(props,ff.input.value,fs.input.value,f);}}/></Tooltip>
                :<Tooltip title='Send sequence'><ScheduleIcon color='primary' style={{cursor:'pointer'}} onClick={()=>{setAiTemplate(false); setSequence(true);setTemplate(false);sequenceChange(props,ff.input.value,fs.input.value,f);}}/></Tooltip>
              }
          </div>}
        </Fragment>}</Field>}</Field>}</Field>}</Field>
        <Typography variant='caption' style={{position:'absolute', top:'35px', right:'20px'}}>{(schedule==true)?null:<span style={{marginLeft:'20px', cursor:'pointer'}} onClick={()=>{setSchedule(true);}}>Schedule</span>}{(cc==true)?null:<span style={{marginLeft:'20px', cursor:'pointer'}} onClick={()=>{setCc(true);}}>Cc</span>}{(bcc==true)?null:<span style={{marginLeft:'20px', cursor:'pointer'}} onClick={()=>{setBcc(true);}}>Bcc</span>}{(reply_to==true)?null:<span style={{marginLeft:'20px', cursor:'pointer'}} onClick={()=>{setReplyTo(true);}}>Reply to</span>}</Typography>



        <Field name='date_time'>{(fdt)=>{if(updateDateTime==undefined){setUpdateDateTime(fdt.input);} return (null);}}</Field>



        <Grid container style={{width:'calc(100% - 40px)', marginTop:'10px'}}>
            {(schedule==false)?null:<Fragment><Grid item xs={12} sm={6} md={4} style={{marginBottom:'10px'}}><Field name='date_time'>{(f)=><Date_picker date_time title='Date' value={f.input.value} onChange={f.input.onChange}/>}</Field></Grid><Grid item xs={6} md={8}/></Fragment>}
            {(template==true)?<Field name='reply_to_address'>{(f)=><Field name='template_id'>{(ft)=><Grid item xs={12} sm={6} md={4}><Select required title='From' name='from_id' onChange={(e)=>{fromChange(props, e.target.value, ft.input.value, f);}} select_data={from_list}/></Grid>}</Field>}</Field>
              :(sequence==true)?<Field name='reply_to_address'>{(f)=><Field name='sequence_id'>{(fs)=><Grid item xs={12} sm={6} md={4}><Select required title='From' name='from_id' onChange={(e)=>{fromChange(props, e.target.value, fs.input.value, f, true);}} select_data={from_list}/></Grid>}</Field>}</Field>
              :<Field name='reply_to_address'>{(f)=><Grid item xs={12} sm={6} md={4}><Select required title='From' name='from_id' select_data={from_list} onChange={(e)=>{fromChange(props, e.target.value, undefined, f);}}/></Grid>}</Field>
            }
            {(props.company==undefined)?null:<Grid item xs={12} sm={6} md={4}><Select required title='To' name='contact_email_id' select_data={to_list} onChange={(e)=>{setContactEmail(e.target.value); for(let x of to_list){if(x.id==e.target.value){setContactId(x.contact_id);}}}}/></Grid>}
            <Grid item xs={12} sm={6} md={4}><DealSelect {...props}/></Grid>

            <Grid item xs={12}/>
            {(cc==false)?null:<Grid item xs={12} sm={6} style={{marginTop:'-20px'}}>{(cc==false)?null:<Field name={`cc`}>{(f)=><Chip_input title='Cc' no_title name='cc' value={f.input.value} onChange={f.input.onChange} value_name='email'/>}</Field>}</Grid>}
            {(bcc==false)?null:<Grid item xs={12} sm={6} style={{marginTop:'-20px'}}>{(bcc==false)?null:<Field name={`bcc`}>{(f)=><Chip_input title='Bcc' no_title name='bcc' value={f.input.value} onChange={f.input.onChange} value_name='email'/>}</Field>}</Grid>}
            {(reply_to==false)?null:<Grid item xs={12} sm={6} md={4} style={{marginBottom:'10px'}}><Text title='Reply to' name='reply_to_address'/></Grid>}

            <Grid item xs={12}/>
            <Field name='contact_email_id'>{(f)=>(f.input.value==undefined || f.input.value=='')?null:<Grid item xs={12} sm={6}><Verification_status_box {...props}/></Grid>}</Field>
            <Grid item xs={12} sm={6}><Unsubscribe_button {...props}/></Grid>
            {(template==true || ai_template==true)?
                      <Fragment>
                        <Field name='reply_to_address'>{(f)=><Field name='from_id'>{(ff)=>
                          <Fragment>
                            <Grid item xs={12} style={{height:'10px'}}/>
                       <FolderSelector default={first_template_folder} title="Template Folder" folder_type="TEMPLATES" resources={(ai_template == true) ? ai_template_list : template_list} displayResourceSelector={(resources)=>{
                              return(
                                <Grid item xs={12} sm={6} md={4}>{
                                  (ai_template == true && resources.length == 0) ? <Typography style={{ cursor: 'pointer', textDecoration: 'underline' }} variant='caption' color='primary' onClick={() => { window.location.href = '/email/templates/new' }}>Create an Ai Template</Typography>
                                    : <Select title={(ai_template == true) ? 'Ai Template' : 'Template'} required name='template_id' select_data={resources} onChange={(e) => { templateChange(props, ff.input.value, e.target.value, f); }} style={{ maginBottom: '5px', marginTop: '0px' }} />
                                }</Grid>
                              )
                            }}/>
                            
                            <Grid item xs={6} style={{marginTop:'10px'}}><Field name='subject'>{(f_subject)=><Field name='content'>{(f_content)=><Field name='contact_id'>{(fc)=><Field name='template_id'>{(f)=>{let template=(props.templates!=undefined)?props.templates[f.input.value]:undefined; if(template==undefined || template.template_type!='AI_TEMPLATE'){return null;} return(<Button color='secondary' variant='contained' onClick={()=>{generateAiEmail(fc.input.value, f.input.value, f_subject, f_content);}}>{(ai_email_loading=='loaded')?'Regenerate':'Generate email'}</Button>)}}</Field>}</Field>}</Field>}</Field></Grid>
                          </Fragment>
                        }</Field>}</Field>
                        <Grid item xs={12} style={{marginTop:'5px'}}><Field name='template_id'>{(f)=><Fragment><TemplateNotes {...props} setPreviewPopup={setPreviewPopup} template_id={(f.input.value=='')?undefined:f.input.value}/><Placeholders {...props} contact={contact} template_id={(f.input.value=='')?undefined:f.input.value}/></Fragment>}</Field></Grid>
                        {(ai_template!=true || ai_email_loading==undefined)?null:(ai_email_loading=='loading')?
                          <div style={{width:'100%', height:'100px'}}><Loader embed loading small/></div>
                          :<Fragment>
                            <Grid item xs={12}><Text required title='Subject' name='subject' error={subject_required} helperText={(subject_required==true)?'Required':undefined} /></Grid>
                            <Grid item xs={12}><div style={{width:'calc(100% - 20px)', marginLeft:'10px', marginTop:'5px'}}><Field name='content'>{(f)=><TextEditor required value={f.input.value} onChange={(e)=>{f.input.onChange(e)}}/>}</Field></div></Grid>
                           </Fragment>
                        }
                      </Fragment>
             :(sequence==true)?
                      <Fragment>
                     <Grid item xs={12} style={{ height: '10px' }} />
                        <Field name='reply_to_address'>{(f)=><Field name='from_id'>{(ff)=>
                        <FolderSelector default={first_sequence_folder} title="Sequence Folder" folder_type="SEQUENCES" resources={sequence_list} displayResourceSelector={(resources)=>{
                              return(
                                <Grid item xs={12} sm={6} md={4}><Select title='Sequence' required name='sequence_id' select_data={resources} style={{ marginTop: '0px' }} onChange={(e) => { sequenceChange(props, ff.input.value, e.target.value, f); }} /></Grid>
                              )
                            }}/>
                        }</Field>}</Field>
                        <Field name='sequence_id'>{(f)=>{return(<Fragment>{(f.input.value!=undefined && props.sequences[Number(f.input.value)]!=undefined)?<Grid item xs={12} style={{marginTop:'10px'}}>{props.sequences[Number(f.input.value)].sequence_emails.map(function(se, index){
                          let html_template=props.templates[se.html_template_id];
                          let wait_types=['seconds','minutes','hours','days','weeks','months'];
                          return(<div><Typography style={{marginLeft:'10px'}} variant='caption'><span style={{fontWeight:'bold'}}>{'Wait '+se.wait+' '+wait_types[se.type]+': '}</span><span>{html_template.name}</span><Typography variant='caption' style={{textDecoration:'underline', cursor:'pointer', marginLeft:'20px'}} onClick={()=>{setPreviewPopup(html_template);}} color="primary">(preview)</Typography></Typography></div>)
                        })}</Grid>:null}</Fragment>)}}</Field>
                        <Grid item xs={12} style={{marginTop:'5px'}}><Field name='sequence_id'>{(f)=><Placeholders {...props} contact={contact} changeDefaultDate={changeDefaultDate} updateDateTimeFunc={updateDateTime} sequence_id={(f.input.value=='')?undefined:f.input.value}/>}</Field></Grid>
                      </Fragment>
              :
                      <Fragment>
                        <Grid item xs={12}><Text required title='Subject' name='subject' error={subject_required} helperText={(subject_required==true)?'Required':undefined} /></Grid>
                        <Grid item xs={12}><div style={{width:'calc(100% - 20px)', marginLeft:'10px', marginTop:'5px'}}><Field name='content'>{(f)=><TextEditor required value={f.input.value} onChange={(e)=>{f.input.onChange(e)}}/>}</Field></div></Grid>
                        <Grid item xs={12}><Uploader margin_top='10px' margin_bottom='0px' title='Attach files to email' button_text='Upload' submitted_text='Uploaded'/></Grid>
                      </Fragment>
            }
        </Grid>
        </div>
      }</form>
      )}}
      </Form>
      }/>
      {(preview_popup==undefined)?null:<Preview_popup template={preview_popup} handleClose={()=>{setPreviewPopup(undefined)}}/>}
      </Fragment>
  )
}


function getTemplate(props, id){
  let template=undefined; if(props.templates!=undefined && props.templates[id]!=undefined){template=props.templates[id];}
  if(template!=undefined){if(template.reply_to_address==null || template.reply_to_address===''){template.reply_to_address=undefined;}}
  console.log('TEMPLATE SELECTED', template);
  return template;
}

function getTemplateFromSequence(props, id){
  let sequence=undefined; if(props.sequences!=undefined && props.sequences[id]!=undefined){sequence=props.sequences[id];}
  let es=(sequence!=undefined)?sequence.sequence_emails[0]:undefined;
  return getTemplate(props, (es==undefined)?undefined:es.html_template_id);
}

function getFrom(props, id){
  let from={}; for(let ga of props.gmail.addresses){if(ga.id==id){from=ga;}}
  if(from.reply_to_address==null || from.reply_to_address===''){from.reply_to_address=undefined;}
  console.log('FROM SELECTED', from);
  return from;
}



function Unsubscribe_button(props){
  return(<div style={{marginTop:'10px', marginLeft:'10px'}}><FormControlLabel control={<Field name='unsubscribe_button'>{(f)=><Checkbox checked={f.input.value} onClick={(e)=>{let checked=!f.input.value; f.input.onChange(checked);}} name="unsubscribe_button" />}</Field>} label="Include unsubscribe link" /></div>)
}

function Verification_status_box(props){
  return(
    <div style={{marginBottom:'10px', marginTop:'10px'}}>
    <Field name="contact_email_id">{(f)=>{
      let contact_email=undefined; if(props.company!=undefined && props.company.contacts!=undefined){for(let c of props.company.contacts){for(let ce of c.contact_emails){if(ce.id==f.input.value){contact_email=ce;}}}}
      if(contact_email==undefined){return null;}

      let arr=window.getQuickEmailStatus(contact_email, false);
      let es=arr.value;
      let es_enum=arr.enum;
      let borderColor =(es=='INVALID' || es=='BOUNCED' || es=='UNSUBSCRIBED' || es=='TEMPORARY' || es=='SOFT_BOUNCED' || es=='SPAM_COMPLAINT' || es=='VERY_RISKY')?'red':(es=='UNRESPONSIVE' || es=='RISKY' || es=='WEBMAIL' || es=='ACCEPT_ALL')?'orange':(es=='DELIVERED' || es=='RECEIVED' || es=='VERIFIED' || es=='CLICKED' || es=='OPENED')?'green':'red';
      let percent=0; if(contact_email.email_score!=undefined){percent=contact_email.email_score;}
      if(percent>0){percent=percent/100;}
      console.log(es, 'EEEESSS', contact_email);

      return(<Fragment>
        <div style={{display:'flex',position:'relative'}}>
        <span style={{width:(es=='UNKNOWN')?'100px':'60px', marginLeft:'10px'}}>{
          (es=='UNKNOWN' || es=='GENERIC')?<Tooltip title='This action will cost 0.5 credit'><Button color='secondary' variant='contained' onClick={()=>{if(props.email_enrichment_disabled==true){props.setAddOnMarketing.current(true);}else{props.verifyNow(contact_email.contact_id, props.company.id)}}}>Verify</Button></Tooltip>
          :<Tooltip title={<Enumeration enum={es_enum} return="description" value={es}/>}><GaugeChart id="gauge-chart3" nrOfLevels={100} colors={["red", "orange", "green"]} arcsLength={[0.3, 0.4, 0.3]} percent={percent}/></Tooltip>
        }</span>
        <span style={{marginTop:(es=='UNKNOWN')?'5px':'0px'}}><Tooltip title={(es=='UNKNOWN')?'Verify this email to reduce your bounce rate':(es=='ACCEPT_ALL')?'This is a catch all account. Anything @this_domain.com should be accepted. It is not however a good indication that you will be able to reach this person.':<Enumeration enum={es_enum} return="description" value={es}/>}><div style={{cursor:'pointer', marginLeft:'10px', border: `2px solid ${borderColor}`, borderRadius: '5px', padding: '1px 5px'}}><Typography variant='caption'>{'Email status: '}{(es=='UNKNOWN')?'Unknown':(es=='ACCEPT_ALL')?'Accept all':<Enumeration enum={es_enum} value={es}/>}</Typography></div></Tooltip></span>
        </div>
        {(es=='INVALID' || es=='BOUNCED' || es=='UNSUBSCRIBED' || es=='TEMPORARY' || es=='VERY_RISKY')?<div style={{marginLeft:'10px'}}><Typography variant='caption' color='error'>We recommend not to send an email to this address!</Typography></div>:null}
        </Fragment>
      )
    }}</Field></div>
  )
}


function Placeholders(props){
  let placeholders=[];
  let template_ids;
  let plus_ss=useRef(undefined);

  if(props.template_id!=undefined && props.templates[props.template_id]!=undefined){template_ids=[props.template_id];}
  else if(props.sequence_id!=undefined){template_ids=[]; if(props.sequences[props.sequence_id]!=undefined){for(let s of props.sequences[props.sequence_id].sequence_emails){template_ids.push(s.html_template_id);}}}
  if(template_ids!=undefined){
    for(let template_id of template_ids){
      console.log('TID', template_id, props.templates);
      let template_html=props.templates[template_id].html;
      let array=template_html.match(/\$\{[^\}]*\}/g);
      if(array!=null){for(let ot of array){
        if(ot.toUpperCase()!='${FIRST_NAME}' && ot.toUpperCase()!='${LAST_NAME}' && ot.toUpperCase()!='${CITY}' && ot.toUpperCase()!='${COMPANY_NAME}'){
          let nt=ot.replace('${', '').replace('}','').toLowerCase().replace('_',' ');
          nt=nt[0].toUpperCase() + nt.substring(1);
          if(!placeholders.includes(nt)){placeholders.push({name:nt, template_name:props.templates[template_id].name});}
      }}}
    }
  }
  if(props.sequence_id!=undefined && props.sequences[props.sequence_id]!=undefined && props.updateDateTimeFunc!=undefined){
      let plus_seconds=0; for(let se of props.sequences[props.sequence_id].sequence_emails){if(se.order==0){if(se.type==0){plus_seconds=se.wait;}else if(se.type==1){plus_seconds=(se.wait*60);}else if(se.type==2){plus_seconds=(se.wait*3600);}else if(se.type==3){plus_seconds=(se.wait*3600*24);}else if(se.type==4){plus_seconds=(se.wait*3600*24*7)}else if(se.type==5){plus_seconds=(se.wait*3600*24*30);}}}
      plus_seconds=plus_seconds*1000;
      if(plus_seconds!=plus_ss.current){
        plus_ss.current=plus_seconds;
        let now=new Date();
        let default_date=new Date(now.getTime() + plus_seconds);
        props.changeDefaultDate((plus_seconds==0)?undefined:default_date, props.updateDateTimeFunc);
    }}
  if(props.templates!=undefined && props.template_id!=undefined && props.templates[props.template_id]!=undefined && props.templates[props.template_id].template_type=='AI_TEMPLATE' && placeholders.length==0){return null;}
  if(placeholders.length==0){return <div style={{height:'80px'}}/>;}
  return(
    <Fragment>
    <Grid container style={{width:'100%'}}>
    <Grid item xs={12}><Typography color='primary' style={{marginLeft:'10px', marginTop:'10px', marginBottom:'5px'}}>Placeholders</Typography></Grid>
    {placeholders.map(function(p){
      return(<Grid item xs={12}>
        <div style={{width:'calc(100% - 20px)', marginLeft:'10px'}}>
        <Typography><span>{p.name}</span>{(props.sequence_id!=undefined)?<Typography variant='caption' style={{fontStyle:'italic'}}>{" ("+p.template_name+")"}</Typography>:null}</Typography>
        <Field name={'placeholders.'+p.name.toLowerCase().replace(' ','_')}>{(f)=><TextEditor value={f.input.value} onChange={(e)=>{f.input.onChange(e)}}/>}</Field>
        </div>
        </Grid>)
    })}</Grid>
    </Fragment>
  )
}


function TemplateNotes(props){
  let template; if(props.templates!=undefined && props.template_id!=undefined){template=props.templates[props.template_id];}

  if(template==undefined){return null;}
  return(
    <div style={{width:'calc(100% - 10px)', marginLeft:'10px', marginTop:'10px'}}>
      <Typography color='primary' style={{width:'100%'}}><span>{"Notes  "}</span><Typography style={{fontStyle:'italic', cursor:'pointer', textDecoration:'underline'}} variant="caption" onClick={()=>{props.setPreviewPopup(template);}}>{"(preview "+template.name+")"}</Typography></Typography>
      <Typography variant='caption' style={{width:'100%'}}>{template.notes}</Typography>
    </div>
  )
}


export default connect(ss,dd)(Email_popup)

function ss(state){
  return{
    deals:state.deals.deals,
    main_deals:state.deals.main_deals,
    gmail:state.integrations.gmail,
    templates:state.templates.templates,
    sequences:state.templates.sequences,
    templates_index:state.templates.templates_index,
  }
}

function dd(dispatch){
  return{
    verifyNow:(contact_id, company_id)=>{dispatch({type:'REQUEST_LOADER_NOW', val:true}); dispatch({type:'REQUEST_VERIFY_NOW', contact_id:contact_id, company_id:company_id});},
    getGmailSetup:()=>{dispatch({type:'REQUEST_GET_GMAIL_SETUP'})},
    getTemplates:()=>{dispatch({type:'REQUEST_INDEX_HTML_TEMPLATES'})},
    getSequences:()=>{dispatch({type:'REQUEST_INDEX_EMAIL_SEQUENCES'})}
  }
}
